const isLogin = () => {
    if (localStorage.getItem('admin_wallet_token')) {
        return true;
    }
    return false;
}

export default isLogin;